export default __webpack_public_path__ + "static/media/holdings.5141fa51.svg";